import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from "./api/_index";

import drag from './drag';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueParticles from 'vue-particles';
import Print from 'vue-print-nb';
import Moment from 'moment'

import store from './store';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import vueEsign from 'vue-esign'

import md5 from 'js-md5'
import VueClipboard from 'vue-clipboard2'
// import VueScroller from 'vue-scroller'


// 移动端图片预览
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
    fullscreenEl: false, // 控制是否显示右上角全屏按钮
    closeEl: true,      // 控制是否显示右上角关闭按钮
    tapToClose: true,    // 点击滑动区域应关闭图库
    shareEl: false,      // 控制是否显示分享按钮
    zoomEl: true,       // 控制是否显示放大缩小按钮
    counterEl: false,    // 控制是否显示左上角图片数量按钮
    arrowEl: true,       // 控制如图的左右箭头（pc浏览器模拟手机时）
    tapToToggleControls: true,    // 点击应切换控件的可见性
    clickToCloseNonZoomable: true // 点击图片应关闭图库，仅当图像小于视口的大小时
};
Vue.use(preview, options);

Vue.use(vueEsign);

Vue.use(Print);
Vue.use(VueParticles);
Vue.use(ElementUI);
Vue.use(ViewUI);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
// Vue.use(VueScroller);


import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = Moment
Vue.prototype.$api = api;
Vue.prototype.$md5 = md5;

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
}).$mount('#app');


// vue-html5-editor 富文本编辑器
import VueHtml5Editor from 'vue-html5-editor'
import 'font-awesome/css/font-awesome.css'
Vue.use(VueHtml5Editor, {
    // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
    // global component name
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    // if set true,will append module name to toolbar after icon
    showModuleName: false,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    // custom icon class of built-in modules,default using font-awesome
    icons: {
        text: "fa fa-pencil",
        color: "fa fa-paint-brush",
        font: "fa fa-font",
        align: "fa fa-align-justify",
        list: "fa fa-list",
        link: "fa fa-chain",
        unlink: "fa fa-chain-broken",
        tabulation: "fa fa-table",
        image: "fa fa-file-image-o",
        hr: "fa fa-minus",
        eraser: "fa fa-eraser",
        undo: "fa-undo fa",
        "full-screen": "fa fa-arrows-alt",
        info: "fa fa-info",
    },
    // 配置图片模块
    // config image module
    image: {
        // 文件最大体积，单位字节  max file size
        sizeLimit: 512 * 1024,
        // 上传参数,默认把图片转为base64而不上传
        // upload config,default null and convert image to base64
        upload: {
            url: null,
            headers: {},
            params: {},
            fieldName: {}
        },
        // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
        // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
        // set null to disable compression
        compress: null,
        // compress: {
        //     width: 1600,
        //     height: 1600,
        //     quality: 80
        // },
        // 响应数据处理,最终返回图片链接
        // handle response data，return image url
        uploadHandler(responseText){
            //default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
            var json = JSON.parse(responseText)
            if (!json.ok) {
                alert(json.msg)
            } else {
                return json.data
            }
        }
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    //default en-us, en-us and zh-cn are built-in
    language: "zh-cn",
    // 自定义语言
    i18n: {
        //specify your language here
        "zh-cn": {
            "align": "对齐方式",
            "image": "图片",
            "list": "列表",
            "link": "链接",
            "unlink": "去除链接",
            "table": "表格",
            "font": "文字",
            "full screen": "全屏",
            "text": "排版",
            "eraser": "格式清除",
            "info": "关于",
            "color": "颜色",
            "please enter a url": "请输入地址",
            "create link": "创建链接",
            "bold": "加粗",
            "italic": "倾斜",
            "underline": "下划线",
            "strike through": "删除线",
            "subscript": "上标",
            "superscript": "下标",
            "heading": "标题",
            "font name": "字体",
            "font size": "文字大小",
            "left justify": "左对齐",
            "center justify": "居中",
            "right justify": "右对齐",
            "ordered list": "有序列表",
            "unordered list": "无序列表",
            "fore color": "前景色",
            "background color": "背景色",
            "row count": "行数",
            "column count": "列数",
            "save": "确定",
            "upload": "上传",
            "progress": "进度",
            "unknown": "未知",
            "please wait": "请稍等",
            "error": "错误",
            "abort": "中断",
            "reset": "重置"
        }
    },
    // 隐藏不想要显示出来的模块
    // the modules you don't want
    hiddenModules: [],
    // 自定义要显示的模块，并控制顺序
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
    visibleModules: [
        "text",
        "color",
        "font",
        "align",
        "list",
        "link",
        "unlink",
        "tabulation",
        "image",
        "eraser",
        "undo",
        "full-screen",
    ],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: {
        //omit,reference to source code of build-in modules
    }
})





// 日期格式化
Date.prototype.format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

Date.prototype.add = function (ms) {
    return new Date(this.getTime() + ms);
}

Math.UUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

Math.isNumber = function (val) {
    if (typeof val == 'number') {
        return isFinite(val) ? true : false;
    }
    if (!val) return false;
    let regPos = /^\d+(\.\d+)?$/; //非负浮点数
    let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    return regPos.test(val.toString()) || regNeg.test(val.toString());
}

Math.sum = function (...arr) {
    let notNumber = arr.findIndex(v => !Math.isNumber(v));
    if (notNumber >= 0) return '';
    return arr.reduce((sum, v) => sum += (parseFloat(v) || 0), 0)
}

Math.sub = function (...arr) {
    let notNumber = arr.findIndex(v => !Math.isNumber(v));
    if (notNumber >= 0) return '';
    return 2 * (parseFloat(arr[0]) || 0) - Math.sum(...arr);
}

Math.avg = function (...arr) {
    let notNumber = arr.findIndex(v => !Math.isNumber(v));
    if (notNumber >= 0) return '';
    arr = arr.filter(v => parseFloat(v) || parseFloat(v) == 0);
    return arr.length > 0 ? Math.sum(...arr) / arr.length : 0;
}

Math.fixed = function (a, f, noZero) {
    if (!Math.isNumber(a)) return '';
    a = parseFloat(a), f = !f ? 1 : (parseFloat(Number(f).toFixed(8)) || 1);
    a = f ? (a / f).toFixed(0) * f : a;
    let x = f >= 1 ? 0 : f.toString().split(".")[1].length;
    return noZero ? parseFloat(a.toFixed(x)).toString() : a.toFixed(x);
}

let min = Math.min,
    max = Math.max;
// Math.min = function (...arr) {
//     let notNumber = arr.findIndex(v => !Math.isNumber(v));
//     if (notNumber >= 0) return '';
//     return arr.length > 0 ? min(...arr) : '';
// }

// Math.max = function (...arr) {
//     let notNumber = arr.findIndex(v => !Math.isNumber(v));
//     if (notNumber >= 0) return '';
//     return arr.length > 0 ? max(...arr) : '';
// }

// 待错误参数处理的
Math.sum2 = function (...arr) {
    return arr.reduce((sum, v) => sum += (parseFloat(v) || 0), 0)
}

Math.sub2 = function (...arr) {
    return 2 * (parseFloat(arr[0]) || 0) - Math.sum(...arr);
}

Math.avg2 = (...arr) => {
    arr = arr.filter(v => parseFloat(v) || parseFloat(v) == 0);
    return arr.length > 0 ? Math.sum(...arr) / arr.length : 0;
}

Math.fixed2 = function (a, f) {
    a = parseFloat(a), f = parseFloat(f) || 1;
    a = f ? (a / f).toFixed(0) * f : a;
    return parseFloat(a.toFixed(6));
}

String.prototype.replaceAll = function (s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
}
// window.console.error = function () {};


/** 处理数值数据：四舍六入奇进偶不进
 * 1，如果取小数的最后一位为5，5前为奇数进位，为偶不进,五后非零就进一,五后皆零看奇偶,五前为偶应舍去,五前为奇要进一
 * 2.5后不为0时就入，为0时看5前，奇进偶不进
 * 3.四舍，六入
 * 传入数值和保留位数*/
Math.isBlxs = function (number, fixed = 0) {
    if (!Math.isNumber(number)) return '';
    number = String(number);
    //可以考虑清掉末尾的0，暂时限制了不会有,因为传入数值，末尾0是去掉的
    let index = number.indexOf(".");
    if (index == -1) {
        //没有小数，直接返回
        return number;
    }
    //取到保留小数位的下一位，5.5555取保留俩位，那就是小数点后第三位
    let indexFixed = index + fixed + 1;
    if (indexFixed >= number.length) {
        //如果小数位数不够直接返回
        return number;
    }
    //取保留位数的后一位做判断，以下是有5的判断
    let endNumber = number.substr(indexFixed, 1);
    if (endNumber != "5") {
        //如果做判断的数不是五，就按正常的四舍五入，即忽略了5，后面补0的那些由于是数字传进来，0已经去掉，此处不做处理
        return Number(number).toFixed(fixed);
    }
    if (indexFixed != number.length - 1) {
        //由于当前判断位不是最后一位，而又去除了0，那么后面后的位数应该直接入位，五后不为0时入,由于会有小于五的，四舍五入肯定不行，那么只能截取到当前保留位数，然后转成数字加上10的负fixed的次方即可
        number = number.substring(0, indexFixed)
        if (number.indexOf("-") != -1) { //需要考虑到负数的情况
            return (Number(number) - Number(Math.pow(10, -fixed))).toFixed(fixed);
        }
        return (Number(number) + Number(Math.pow(10, -fixed))).toFixed(fixed);
        //return this.accAdd(number,Math.pow(10,-fixed))
    }
    //接下来就时五后没有值也就是0的需要看前面的奇入偶不入了，取当前位的上一位
    let twoNumber = number.substr(indexFixed - 1, 1);
    if (twoNumber == ".") { //取到小数点，再取一次，要取到小数点左边第一位
        twoNumber = number.substr(indexFixed - 2, 1);
    }
    if ("13579".indexOf(twoNumber) != -1) { //奇进
        number = number.substring(0, indexFixed)
        if (number.indexOf("-") != -1) { //需要考虑到负数的情况
            return (Number(number) - Math.pow(10, -fixed)).toFixed(fixed);
        }
        return (Number(number) + Math.pow(10, -fixed)).toFixed(fixed);
    }
    //偶不进,将取值的当前位数,直接截取字符即可
    return Number(number.substr(0, indexFixed));
}

/*
 oprType:1取整数0/5修约 2取小数0/0.5修约
*/
Math.threeInt = function (number, oprType) {
    if (oprType != 1 && oprType != 2) return '';
    if (!Math.isNumber(number)) return '';
    if (oprType == 1) {
        number = String(number);
        //可以考虑清掉末尾的0，暂时限制了不会有,因为传入数值，末尾0是去掉的
        let index = number.indexOf(".");
        if (index == -1) {
            //没有小数，直接返回
            return number;
        }
        index = index - 1; 
        let intNum = Number(number.substr(0, index) + "0"); 
        let dotNum = Number(number.substr(index, number.length - index));

        if (dotNum >= 0 && dotNum <= 2.5) {
            return intNum;
        }
        if (dotNum > 2.5 && dotNum < 7.5) {
            return intNum + 5;
        }
        if (dotNum >= 7.5 && dotNum < 10) {
            return intNum + 10;
        }
        return intNum;
    } else {
        let intNum = Math.floor(number);
        number = String(number);
        //可以考虑清掉末尾的0，暂时限制了不会有,因为传入数值，末尾0是去掉的
        let index = number.indexOf(".");
        if (index == -1) {
            //没有小数，直接返回
            return number;
        }
        let dotNum = Number("0" + number.substr(index, number.length - index));
        if (dotNum >= 0 && dotNum <= 0.25) {
            return intNum;
        }
        if (dotNum > 0.25 && dotNum < 0.75) {
            return intNum + 0.5;
        }
        if (dotNum >= 0.75 && dotNum < 1) {
            return intNum + 1;
        }
        return intNum;
    }
}


// 修约精度 =========================================

/**
 * 小数位不够自动补 “0”
 * @param num {数值}
 * @param len {保留几位小数}
 */
 var numDecimal = function(num,len) {
    num = ((num || 0).toString().trim() || 0);
    len = ((len || 0).toString().trim() || 0);
    if (len == "0") return num.split(".")[0];
    if (num.toString().indexOf(".") == -1 && len != 0){
        num = (num + ".0");
    }
    var split = num.toString().split(".");
    var decimal = split[1].toString();
    num = split[0].toString();
    if (decimal.length>len){
        decimal = decimal.substring(0,len);
    }else {
        while (decimal.length != len){
            decimal += "0";
        }
    }
    return num+"."+decimal;
}
Math.numDecimal = function(num,len) {
    num = ((num || 0).toString().trim() || 0);
    len = ((len || 0).toString().trim() || 0);
    if (len == "0") return num.split(".")[0];
    if (num.toString().indexOf(".") == -1 && len != 0){
        num = (num + ".0");
    }
    var split = num.toString().split(".");
    var decimal = split[1].toString();
    num = split[0].toString();
    if (decimal.length>len){
        decimal = decimal.substring(0,len);
    }else {
        while (decimal.length != len){
            decimal += "0";
        }
    }
    return num+"."+decimal;
}

/**
 * 四舍五入
 * @param num
 * @param decimalPlaces{小数位}
 * @returns {number}
 */
 var fiveRound = function(num, decimalPlaces) {
    var d = decimalPlaces || 0;
    return Math.round(num * Math.pow(10, d)) / Math.pow(10, d);
}


Math.fomatFloat = function (num,n){   
    var f = parseFloat(num);
    if(isNaN(f)){
        return false;
    }   
    f = Math.round(num  *Math.pow(10, n))/Math.pow(10, n); // n幂   
    var s = f.toString();
    var rs = s.indexOf('.');
    //判定如果是整数，增加小数点再补0
    if(rs < 0){
        rs = s.length;
        s += '.'; 
    }
    while(s.length <= rs + n){
        s += '0';
    }
    return s;
};


/**
 * 四舍六入
 * @param num
 * @param decimalPlaces{小数位}
 * @returns {number}
 */
 var sixRound = function(num, decimalPlaces) {
    var d = decimalPlaces || 0;
    var m = Math.pow(10, d);
    var n = +(d ? num * m : num).toFixed(8);
    var i = Math.floor(n), f = n - i;
    var e = 1e-8;
    var r = (f > 0.5 - e && f < 0.5 + e) ?
        ((i % 2 == 0) ? i : i + 1) : Math.round(n);
    return d ? r / m : r;
}

/**
 * 修约精度
 * @param num{数值}
 * @param len{精度（1、0.5、5、10、0.1、0.01）}
 * @param even{修约（四舍五入、四舍六入）}
 * @returns {number}
 */
 Math.cpEvenRound  = function(num, len, even) {
    try {
        if(isNaN(Number(num))){
            return num;
        }
        num = numDecimal(num,10);
        num = Number(num);
        var d = ((len || 0).toString().trim() || 0);
        var rule = (even!=undefined&&(even.toString().indexOf("5")!=-1||even.toString().indexOf("五")!=-1))?5:6;
        
        if (len=="0.5"){
            //TODO 精度为 0.5 时
            //(0.75 * 2).修约 / 2
            if (rule==5)
                num = fiveRound(num*2,0)/2;//四舍五入
            else
                num = sixRound(num*2,0)/2;//四舍六入
            //小数位自动补 "0"
            num = numDecimal(num,1);
        }else if (len=="5"){
            //TODO 精度为 ”5“ 时 ，个位只会是（0 | 5）
            //(0.75 * 0.2).修约 / 0.2
            if (rule==5)
                num = fiveRound(num*0.2,0)/0.2;//四舍五入
            else
                num = sixRound(num*0.2,0)/0.2;//四舍六入
            //小数位自动补 "0"
            num = numDecimal(num,0);
        }else if (len=="10"){
            //TODO 精度为 ”10“ 时
            //(0.75 / 10).修约 * 10
            if (rule==5)
                num = fiveRound(num/10,0)*10;//四舍五入
            else
                num = sixRound(num/10,0)*10;//四舍六入
        }else {
            //小数点后有几位，就保留几位小数,例：0.1、0.01
            if (len!=undefined&&len.toString().split(".").length>1)
                d = len.toString().split(".")[1].length;
            else d = 0;
            if (rule==5)
                num = fiveRound(num,d);
            else
                num = sixRound(num,d);
            //小数位自动补 "0"
            num = numDecimal(num,d);
        }
    }catch (e) {
        console.log("修约错误："+e.message);
    }
    // console.log("修约结果："+num);
    return num;
}

Math.cpEvenRound2 = function(num,len,even){
    try {
        if(isNaN(Number(num))){
            return num;
        }
        num = numDecimal(num,10);
        num = Number(num);
        var d = ((len || 0).toString().trim() || 0);
        var rule = (even!=undefined&&(even.toString().indexOf("5")!=-1||even.toString().indexOf("五")!=-1))?5:6;
        if (len=="0.5"){
          
        }else if (len=="5"){
            //TODO 精度为 ”5“ 时 ，个位只会是（0 | 5）
            //(0.75 * 0.2).修约 / 0.2
            if (rule==5)
                num = fiveRound(num*0.2,0)/0.2;//四舍五入
            else
                num = sixRound(num*0.2,0)/0.2;//四舍六入
            //小数位自动补 "0"
            num = numDecimal(num,0);
        }else if (len=="10"){
            //TODO 精度为 ”10“ 时
            //(0.75 / 10).修约 * 10
            if (rule==5)
                num = fiveRound(num/10,0)*10;//四舍五入
            else
                num = sixRound(num/10,0)*10;//四舍六入
        }else {
            //小数点后有几位，就保留几位小数,例：0.1、0.01
            if (len!=undefined&&len.toString().split(".").length>1)
                d = len.toString().split(".")[1].length;
            else d = 0;
            if (rule==5)
                num = fiveRound(num,d);
            else
                num = sixRound(num,d);
            //小数位自动补 "0"
            num = numDecimal(num,d);
        }
    }catch (e) {
        console.log("修约错误："+e.message);
    }
    return num;
}


//删除数组中 最大最小值
Math.deleMaxMin = function (arr) {//使用函数表达式定义函数
    var max = arr[0];
    var min = arr[0];
    var maxIndex, minIndex = 0;
    for (var i = 1; i < arr.length; i++) {//循环遍历数组
        if (arr[i] > max) {
            maxIndex = i//找到最大值的下标
        }
        if (arr[i] < min) {
            minIndex = i;//找到最小值下标
        }
    }
    arr.splice(maxIndex,1);//只实现了删除最大值操作
    arr.splice(minIndex,1);
    return arr;
}

/**
 * 截取小数
 * @param num{数值}
 * @param len{截取位数(0.1,0.01)}
 * @returns {number}
 */
Math.CutNum = function(num,len){
    if(isNaN(Number(num))){
        return num;
    }
    if(len == 0.1){
        num = num + ''
        let a = num.indexOf('.')
        a = a + 2
        num = num.slice(0,a)
        return num
    }

    if(len == 0.01){
        num = num + ''
        let a = num.indexOf('.')
        a = a + 3
        num = num.slice(0,a)
        return num
    }
}

Math.formatFloat = function (f, digit) {
    var m = Math.pow(10, digit);
    return Math.round(f * m, 10) / m;
}


/*
   返回值说明
   返回值是一个对象，有如下属性或方法：
   serialData           原始序列数据的拷贝
   newSerialData    新的序列数据（拟合后的）
   maxYPoint          Y值最大点
   minYPoint          Y值最小点
   getYByX              根据x求y值
   getXByY              根据y求x值，注意可能有多个相交点，这个函数返回第1个相交点的x值；此外，所有的相交点，存储在intersects中
                              (当Y值很接近峰值时，可能会返回两个很近的交点，这个时候，需要自行对交点的x值做修约处理后，进行取舍) 


   注意，x求y、y求x时，只有源值在数据区间内才能计算出值，但有两个例外，即  直线不做限制、折线可x求y
*/


//n:多项式曲线拟合的次数
Math.fit = function (serialData, type, n) {

    var r;
    if (serialData == null || serialData.length == 0) {
        r = emptyFit(serialData);
    } else {
        if (type == "最小二乘法直线拟合" || type == "直线" || type == "Line") {
            r = fit_Line(serialData);
        }
        else if (type == "折线连接" || type == "折线" || type == "BorkenLine") {
            r = fit_BorkenLine(serialData);
        }
        else if (type == "三次样条曲线拟合" || type == "三次样条" || type == "San") {
            r = fit_San(serialData);
        }
        else if (type == "多项式曲线拟合" || type == "多项式" || type == "N") {
            var n = n ? n : serialData.length;  //默认拟合次数与数据点数相同
            n = n > serialData.length - 1 ? serialData.length - 1 : n;//最大不能超过点数-1
            n = n < 2 ? 2 : n;//最小不能小于2
            r = fit_N(serialData, n);
        }
        else {
            r = emptyFit(serialData);
        }
    }

    //求坐标轴  倍数、x轴小数、y轴小数(-2表示百位)
    r.getValueRange = function (bs, xxs, yxs) {
        if (r.serialData == null || r.serialData.length == 0) {
            var vr = {};
            vr.xMin = 0;
            vr.xMax = 0;
            vr.yMin = 0;
            vr.yMax = 0;
            return vr;
        }

        var xMin = r.serialData[0][0];
        var xMax = r.serialData[r.serialData.length - 1][0];
        var xx = xMax - xMin;
        xx = xx * bs;
        xMin = xMin - xx;
        xMin = rd(xMin, xxs);
        xMax = xMax + xx;
        xMax = rd(xMax, xxs);

        var yMin = r.minYPoint[1];
        var yMax = r.maxYPoint[1];
        var yy = yMax - yMin;
        yy = yy * bs;
        yMin = yMin - yy;
        yMin = rd(yMin, yxs);
        yMax = yMax + yy;
        yMax = rd(yMax, yxs);

        var vr = {};
        vr.xMin = xMin;
        vr.xMax = xMax;
        vr.yMin = yMin;
        vr.yMax = yMax;
        return vr;
    };

    return r;
}


function emptyFit(serialData) {
    var r = {};
    r.getYByX = function (x) {
        return null;
    };
    r.getXByY = function (y) {
        return null;
    };
    r.maxYPoint = [0, 0];
    r.minYPoint = [0, 0];
    r.serialData = JSON.parse(JSON.stringify(serialData));
    r.newSerialData = JSON.parse(JSON.stringify(serialData));

    return r;
}


//折线连接
function fit_BorkenLine(serialData) {
    //公式
    var r = {};
    r.serialData = JSON.parse(JSON.stringify(serialData));
    r.intersects = [];  //根据y值划直线的相交点
    r.getYByX = function (x) {
        var N = r.serialData.length;
        var pp1;
        var pp2;
        if (x < r.serialData[0][0]) {
            pp1 = r.serialData[0];
            pp2 = r.serialData[1];
        }
        else if (x > r.serialData[N - 1][0]) {
            pp1 = r.serialData[N - 2];
            pp2 = r.serialData[N - 1];
        }
        else {
            for (var i = 0; i <= N - 2; i++) {
                if (x >= r.serialData[i][0] && x <= r.serialData[i + 1][0]) {
                    pp1 = r.serialData[i];
                    pp2 = r.serialData[i + 1];
                }
            }
        }

        var y = (x - pp2[0]) * (pp1[1] - pp2[1]) / (pp1[0] - pp2[0]) + pp2[1];
        return y;
    };
    r.getXByY = function (y) {
        r.intersects = [];
        var N = r.serialData.length;
        var pp1;
        var pp2;
        var pushedXValues = [];
        for (var i = 0; i <= N - 2; i++) {
            if ((y >= r.serialData[i][1] && y <= r.serialData[i + 1][1])
                || (y <= r.serialData[i][1] && y >= r.serialData[i + 1][1])) {
                pp1 = r.serialData[i];
                pp2 = r.serialData[i + 1];
                var x = (y - pp2[1]) * (pp1[0] - pp2[0]) / (pp1[1] - pp2[1]) + pp2[0];

                var xPushed = false;//检查x值是否记录过
                for (var j = 0; j < pushedXValues.length; j++) {
                    if (x == pushedXValues[j]) {
                        xPushed = true;
                        break;
                    }
                }

                if (!xPushed) {
                    pushedXValues.push(x);  //将x值记录一下避免重复
                    var p = [];
                    p.push(x);
                    p.push(y);
                    r.intersects.push(p);
                }
            }
        }
        return r.intersects.length == 0 ? null : r.intersects[0][0];
    };

    //拟合点
    r.newSerialData = JSON.parse(JSON.stringify(serialData));

    //最大最小值 
    var maxYPoint = r.newSerialData[0];
    var minYPoint = r.newSerialData[0];
    for (var i = 0; i < r.newSerialData.length; i++) {
        var d = r.newSerialData[i];
        if (d[1] > maxYPoint[1]) {
            maxYPoint = d;
        }
        if (d[1] < minYPoint[1]) {
            minYPoint = d;
        }
    }
    r.maxYPoint = maxYPoint;
    r.minYPoint = minYPoint;

    //console.info(r);
    return r;
}


//最小二乘法直线拟合  y = a + b*x;
function fit_Line(serialData) {
    var X = [];
    var Y = [];
    for (var i = 0; i < serialData.length; i++) {
        var xValue = serialData[i][0];
        var yValue = serialData[i][1];
        X.push(xValue);
        Y.push(yValue);
    }

    //拟合
    var SX, SY, ST2, SS, SXOSS, T;
    var A, B;

    SX = 0;
    SY = 0;
    ST2 = 0;
    B = 0;

    for (var I = 0; I < X.length; I++) {
        SX = SX + X[I];
        SY = SY + Y[I];
    }
    SS = X.length;

    SXOSS = SX / SS;

    for (var I = 0; I < X.length; I++) {
        T = X[I] - SXOSS;
        ST2 = ST2 + T * T;
        B = B + T * Y[I];
    }

    B = B / ST2;
    A = (SY - SX * B) / SS;

    //公式
    var r = {};
    r.serialData = JSON.parse(JSON.stringify(serialData));
    r.a = A;
    r.b = B;
    r.getYByX = function (x) {
        var y = r.a + r.b * x;
        return y;
    };
    r.getXByY = function (y) {
        r.intersects = [];
        var x = (y - r.a) / r.b;

        var p = [];
        p.push(x);
        p.push(y);
        r.intersects.push(p);

        return x;
    };

    //拟合点
    var newSerialData = JSON.parse(JSON.stringify(serialData));
    for (var i = 0; i < newSerialData.length; i++) {
        var xValue = newSerialData[i][0];
        var yValue = r.getYByX(xValue);
        newSerialData[i][1] = yValue;
    }
    r.newSerialData = newSerialData;

    //最大最小值 
    var maxYPoint = r.newSerialData[0];
    var minYPoint = r.newSerialData[0];
    for (var i = 0; i < r.newSerialData.length; i++) {
        var d = r.newSerialData[i];
        if (d[1] > maxYPoint[1]) {
            maxYPoint = d;
        }
        if (d[1] < minYPoint[1]) {
            minYPoint = d;
        }
    }
    r.maxYPoint = maxYPoint;
    r.minYPoint = minYPoint;

    //console.info(r);
    return r;
}

//三次样条拟合
function fit_San(serialData) {
    var p = serialData;
    var N = p.length;
    var x = [];
    var y = [];
    for (var i = 0; i < p.length; i++) {
        x.push(p[i][0]);
        y.push(p[i][1]);
    }
    //var mcs = new MonotonicCubicSpline(x, y);
    var mcs = new CubicSpline(x, y, 0, 0);

    var t = [];
    var z = [];
    if (p.length > 0) {
        var step = (p[p.length - 1][0] - p[0][0]) / 1000;
        var i = p[0][0];
        while (i <= p[N - 1][0]) {
            t.push(i);
            var y = mcs.interpolate(i);
            z.push(y);

            if (i == p[N - 1][0]) {
                break;
            }
            i = i + step;
            if (i > p[N - 1][0]) {
                i = p[N - 1][0];//不能大过x的最大值
            }
        }
    }

    //拟合点
    var r = {};
    r.serialData = JSON.parse(JSON.stringify(serialData));
    r.mcs = mcs;
    r.newSerialData = [];
    for (var i = 0; i < z.length; i++) {
        var item = [];
        item.push(t[i]);
        item.push(z[i]);
        r.newSerialData.push(item);
    }

    //公式
    r.getYByX = function (x) {
        var y = mcs.interpolate(x);
        return y;
    };
    setGetXByYFunction(r);

    //最大最小值
    var maxYPoint = r.newSerialData.length > 0 ? r.newSerialData[0] : null;
    var minYPoint = r.newSerialData.length > 0 ? r.newSerialData[0] : null;
    for (var i = 0; i < r.newSerialData.length; i++) {
        var d = r.newSerialData[i];
        if (d[1] > maxYPoint[1]) {
            maxYPoint = d;
        }
        if (d[1] < minYPoint[1]) {
            minYPoint = d;
        }
    }
    r.maxYPoint = maxYPoint;
    r.minYPoint = minYPoint;

    //console.info(r);
    return r;
}

//判断两个斜率是否改变方向（0变非0不算）
function signChanged(v1, v2) {
    var s1 = getSign(v1);
    var s2 = getSign(v2);

    //没有改变
    if (s1 == s2) {
        return false;
    }

    //改变了
    if (v1 == 0) {
        return false;
    } else {
        return true;
    }
}

function getSign(v) {
    if (v < 0) {
        return -1;
    } else if (v > 0) {
        return 1;
    } else {
        return 0;
    }
}


//N次多项式拟合
function fit_N(serialData, n) {
    var p = serialData;
    var X = [];
    var Y = [];
    for (var i = 0; i < serialData.length; i++) {
        var xValue = serialData[i][0];
        var yValue = serialData[i][1];
        X.push(xValue);
        Y.push(yValue);
    }

    var xs = [];
    for (var i = 0; i <= n; i++) {
        xs.push(0);
    }
    var pff = new PolyFitForcast();
    xs = pff.PolyFit(X, Y, p.length, xs, n + 1);

    //公式
    var r = {};
    r.serialData = JSON.parse(JSON.stringify(serialData));
    r.pff = pff;
    r.xs = xs;
    r.n = n;
    r.X = X;
    r.Y = Y;
    r.cal = function (x) {
        var y = r.pff.getY(x, r.X, r.xs, r.n + 1);
        return y;
    };
    r.getYByX = function (x) {
        var y = r.cal(x);
        return y;
    };

    //拟合点
    r.newSerialData = [];
    if (p.length > 0) {
        var step = (p[p.length - 1][0] - p[0][0]) / 1000;
        var i = p[0][0];
        while (i <= p[p.length - 1][0]) {
            var y = r.cal(i);
            var item = [];
            item.push(i);
            item.push(y);
            r.newSerialData.push(item);

            if (i == p[p.length - 1][0]) {
                break;
            }
            i = i + step;
            if (i > p[p.length - 1][0]) {
                i = p[p.length - 1][0];//不能大过x的最大值
            }
        }
    }
    setGetXByYFunction(r);//这个是根据拟合点反求，所以要在设置拟合点后再调用

    //最大最小值
    var maxYPoint = r.newSerialData.length > 0 ? r.newSerialData[0] : null;
    var minYPoint = r.newSerialData.length > 0 ? r.newSerialData[0] : null;
    for (var i = 0; i < r.newSerialData.length; i++) {
        var d = r.newSerialData[i];
        if (d[1] > maxYPoint[1]) {
            maxYPoint = d;
        }
        if (d[1] < minYPoint[1]) {
            minYPoint = d;
        }
    }
    r.maxYPoint = maxYPoint;
    r.minYPoint = minYPoint;

    console.info(r);
    return r;
}





var CubicSpline, MonotonicCubicSpline;
MonotonicCubicSpline = function () {
    function MonotonicCubicSpline(x, y) {
        var alpha, beta, delta, dist, i, m, n, tau, to_fix, _i, _j, _len, _len2, _ref, _ref2, _ref3, _ref4;
        n = x.length;
        delta = [];
        m = [];
        alpha = [];
        beta = [];
        dist = [];
        tau = [];
        for (i = 0, _ref = n - 1; (0 <= _ref ? i < _ref : i > _ref); (0 <= _ref ? i += 1 : i -= 1)) {
            delta[i] = (y[i + 1] - y[i]) / (x[i + 1] - x[i]);
            if (i > 0) {
                m[i] = (delta[i - 1] + delta[i]) / 2;
            }
        }
        m[0] = delta[0];
        m[n - 1] = delta[n - 2];
        to_fix = [];
        for (i = 0, _ref2 = n - 1; (0 <= _ref2 ? i < _ref2 : i > _ref2); (0 <= _ref2 ? i += 1 : i -= 1)) {
            if (delta[i] === 0) {
                to_fix.push(i);
            }
        }
        for (_i = 0, _len = to_fix.length; _i < _len; _i++) {
            i = to_fix[_i];
            m[i] = m[i + 1] = 0;
        }
        for (i = 0, _ref3 = n - 1; (0 <= _ref3 ? i < _ref3 : i > _ref3); (0 <= _ref3 ? i += 1 : i -= 1)) {
            alpha[i] = m[i] / delta[i];
            beta[i] = m[i + 1] / delta[i];
            dist[i] = Math.pow(alpha[i], 2) + Math.pow(beta[i], 2);
            tau[i] = 3 / Math.sqrt(dist[i]);
        }
        to_fix = [];
        for (i = 0, _ref4 = n - 1; (0 <= _ref4 ? i < _ref4 : i > _ref4); (0 <= _ref4 ? i += 1 : i -= 1)) {
            if (dist[i] > 9) {
                to_fix.push(i);
            }
        }
        for (_j = 0, _len2 = to_fix.length; _j < _len2; _j++) {
            i = to_fix[_j];
            m[i] = tau[i] * alpha[i] * delta[i];
            m[i + 1] = tau[i] * beta[i] * delta[i];
        }
        this.x = x.slice(0, n);
        this.y = y.slice(0, n);
        this.m = m;
    }
    MonotonicCubicSpline.prototype.interpolate = function (x) {
        var h, h00, h01, h10, h11, i, t, t2, t3, y, _ref;
        for (i = _ref = this.x.length - 2; (_ref <= 0 ? i <= 0 : i >= 0); (_ref <= 0 ? i += 1 : i -= 1)) {
            if (this.x[i] <= x) {
                break;
            }
        }
        h = this.x[i + 1] - this.x[i];
        t = (x - this.x[i]) / h;
        t2 = Math.pow(t, 2);
        t3 = Math.pow(t, 3);
        h00 = 2 * t3 - 3 * t2 + 1;
        h10 = t3 - 2 * t2 + t;
        h01 = -2 * t3 + 3 * t2;
        h11 = t3 - t2;
        y = h00 * this.y[i] + h10 * h * this.m[i] + h01 * this.y[i + 1] + h11 * h * this.m[i + 1];
        return y;
    };
    return MonotonicCubicSpline;
}();
CubicSpline = function () {
    function CubicSpline(x, a, d0, dn) {
        var b, c, clamped, d, h, i, k, l, n, s, u, y, z, _ref;
        if (!((x != null) && (a != null))) {
            return;
        }
        clamped = (d0 != null) && (dn != null);
        n = x.length - 1;
        h = [];
        y = [];
        l = [];
        u = [];
        z = [];
        c = [];
        b = [];
        d = [];
        k = [];
        s = [];
        for (i = 0; (0 <= n ? i < n : i > n); (0 <= n ? i += 1 : i -= 1)) {
            h[i] = x[i + 1] - x[i];
            k[i] = a[i + 1] - a[i];
            s[i] = k[i] / h[i];
        }
        if (clamped) {
            y[0] = 3 * (a[1] - a[0]) / h[0] - 3 * d0;
            y[n] = 3 * dn - 3 * (a[n] - a[n - 1]) / h[n - 1];
        }
        for (i = 1; (1 <= n ? i < n : i > n); (1 <= n ? i += 1 : i -= 1)) {
            y[i] = 3 / h[i] * (a[i + 1] - a[i]) - 3 / h[i - 1] * (a[i] - a[i - 1]);
        }
        if (clamped) {
            l[0] = 2 * h[0];
            u[0] = 0.5;
            z[0] = y[0] / l[0];
        } else {
            l[0] = 1;
            u[0] = 0;
            z[0] = 0;
        }
        for (i = 1; (1 <= n ? i < n : i > n); (1 <= n ? i += 1 : i -= 1)) {
            l[i] = 2 * (x[i + 1] - x[i - 1]) - h[i - 1] * u[i - 1];
            u[i] = h[i] / l[i];
            z[i] = (y[i] - h[i - 1] * z[i - 1]) / l[i];
        }
        if (clamped) {
            l[n] = h[n - 1] * (2 - u[n - 1]);
            z[n] = (y[n] - h[n - 1] * z[n - 1]) / l[n];
            c[n] = z[n];
        } else {
            l[n] = 1;
            z[n] = 0;
            c[n] = 0;
        }
        for (i = _ref = n - 1; (_ref <= 0 ? i <= 0 : i >= 0); (_ref <= 0 ? i += 1 : i -= 1)) {
            c[i] = z[i] - u[i] * c[i + 1];
            b[i] = (a[i + 1] - a[i]) / h[i] - h[i] * (c[i + 1] + 2 * c[i]) / 3;
            d[i] = (c[i + 1] - c[i]) / (3 * h[i]);
        }
        this.x = x.slice(0, n + 1);
        this.a = a.slice(0, n);
        this.b = b;
        this.c = c.slice(0, n);
        this.d = d;
    }
    CubicSpline.prototype.derivative = function () {
        var c, d, s, x, _i, _j, _len, _len2, _ref, _ref2, _ref3;
        s = new this.constructor();
        s.x = this.x.slice(0, this.x.length);
        s.a = this.b.slice(0, this.b.length);
        _ref = this.c;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            c = _ref[_i];
            s.b = 2 * c;
        }
        _ref2 = this.d;
        for (_j = 0, _len2 = _ref2.length; _j < _len2; _j++) {
            d = _ref2[_j];
            s.c = 3 * d;
        }
        for (x = 0, _ref3 = this.d.length; (0 <= _ref3 ? x < _ref3 : x > _ref3); (0 <= _ref3 ? x += 1 : x -= 1)) {
            s.d = 0;
        }
        return s;
    };
    CubicSpline.prototype.interpolate = function (x) {
        var deltaX, i, y, _ref;
        for (i = _ref = this.x.length - 1; (_ref <= 0 ? i <= 0 : i >= 0); (_ref <= 0 ? i += 1 : i -= 1)) {
            if (this.x[i] <= x) {
                break;
            }
        }
        deltaX = x - this.x[i];
        y = this.a[i] + this.b[i] * deltaX + this.c[i] * Math.pow(deltaX, 2) + this.d[i] * Math.pow(deltaX, 3);
        return y;
    };
    return CubicSpline;
}();

function inputMatrix_cal(x, n) {
    var top = 0.0;
    for (var i = 0; i < n; i++) {
        top += inputMatrix[i][n] * Math.pow(x, (n - 1 - i));
    }
    return top;
}

function PolyFitForcast() {
    /**
     * <p>
     * 函数功能：最小二乘法曲线拟合
     * </p>
     * <p>
     * 方程:Y = a(0) + a(1) * (X - X1)+ a(2) * (X - X1)^2 + ..... .+ a(m) * (X -
     * X1)^m X1为X的平均数
     * </p>
     * 
     * @param x
     *			实型一维数组,长度为 n. 存放给定 n 个数据点的 X 坐标
     * @param y
     *			实型一维数组,长度为 n.存放给定 n 个数据点的 Y 坐标
     * @param n
     *			变量。给定数据点的个数
     * @param a
     *			实型一维数组，长度为 m.返回 m-1 次拟合多项式的 m 个系数
     * @param m
     *			拟合多项式的项数，即拟合多项式的最高次数为 m-1. 要求 m<=n 且m<=20。若 m>n 或 m>20
     *			，则本函数自动按 m=min{n,20} 处理.
     *			<p>
     *			Date:2007-12-25 16:21 PM
     *			</p>
     * @author qingbao-gao
     * @return 多项式系数存储数组
     */
    this.PolyFit = function (x, y, n, a, m) {
        var i, j, k;
        var z, p, c, g, q = 0, d1, d2;
        var s = new Array(20);
        var t = new Array(20);
        var b = new Array(20);
        var dt = new Array(3);
        for (i = 0; i <= m - 1; i++) {
            a[i] = 0.0;
        }
        if (m > n) {
            m = n;
        }
        if (m > 20) {
            m = 20;
        }
        z = 0.0;
        for (i = 0; i <= n - 1; i++) {
            z = z + x[i] / (1.0 * n);
        }
        b[0] = 1.0;
        d1 = 1.0 * n;
        p = 0.0;
        c = 0.0;
        for (i = 0; i <= n - 1; i++) {
            p = p + (x[i] - z);
            c = c + y[i];
        }
        c = c / d1;
        p = p / d1;
        a[0] = c * b[0];
        if (m > 1) {
            t[1] = 1.0;
            t[0] = -p;
            d2 = 0.0;
            c = 0.0;
            g = 0.0;
            for (i = 0; i <= n - 1; i++) {
                q = x[i] - z - p;
                d2 = d2 + q * q;
                c = c + y[i] * q;
                g = g + (x[i] - z) * q * q;
            }
            c = c / d2;
            p = g / d2;
            q = d2 / d1;
            d1 = d2;
            a[1] = c * t[1];
            a[0] = c * t[0] + a[0];
        }
        for (j = 2; j <= m - 1; j++) {
            s[j] = t[j - 1];
            s[j - 1] = -p * t[j - 1] + t[j - 2];
            if (j >= 3)
                for (k = j - 2; k >= 1; k--) {
                    s[k] = -p * t[k] + t[k - 1] - q * b[k];
                }
            s[0] = -p * t[0] - q * b[0];
            d2 = 0.0;
            c = 0.0;
            g = 0.0;
            for (i = 0; i <= n - 1; i++) {
                q = s[j];
                for (k = j - 1; k >= 0; k--) {
                    q = q * (x[i] - z) + s[k];
                }
                d2 = d2 + q * q;
                c = c + y[i] * q;
                g = g + (x[i] - z) * q * q;
            }
            c = c / d2;
            p = g / d2;
            q = d2 / d1;
            d1 = d2;
            a[j] = c * s[j];
            t[j] = s[j];
            for (k = j - 1; k >= 0; k--) {
                a[k] = c * s[k] + a[k];
                b[k] = t[k];
                t[k] = s[k];
            }
        }
        dt[0] = 0.0;
        dt[1] = 0.0;
        dt[2] = 0.0;
        for (i = 0; i <= n - 1; i++) {
            q = a[m - 1];
            for (k = m - 2; k >= 0; k--) {
                q = a[k] + q * (x[i] - z);
            }
            p = q - y[i];
            if (Math.abs(p) > dt[2]) {
                dt[2] = Math.abs(p);
            }
            dt[0] = dt[0] + p * p;
            dt[1] = dt[1] + Math.abs(p);
        }
        return a;
    }// end
    /**
     * <p>
     * 对X轴数据节点球平均值
     * </p>
     * 
     * @param x
     *			存储X轴节点的数组
     *			<p>
     *			Date:2007-12-25 20:21 PM
     *			</p>
     * @author qingbao-gao
     * @return 平均值
     */
    this.average = function (x) {
        var ave = 0;
        var sum = 0;
        if (x !== null) {
            for (var i = 0; i < x.length; i++) {
                sum += x[i];
            }
            ave = sum / x.length;
        }
        return ave;
    }
    /**
     * <p>
     * 由X值获得Y值
     * </p>
     * @param x
     *			当前X轴输入值,即为预测的月份
     * @param xx
     *			当前X轴输入值的前X数据点
     * @param a
     *			存储多项式系数的数组
     * @param m
     *			存储多项式的最高次数的数组
     *			<p>
     *			Date:2007-12-25 PM 20:07
     *			</p>
     * @return 对应X轴节点值的Y轴值
     */
    this.getY = function (x, xx, a, m) {
        var y = 0;
        var ave = this.average(xx);
        var l = 0;
        for (var i = 0; i < m; i++) {
            l = a[0];
            if (i > 0) {
                y += a[i] * Math.pow((x - ave), i);
            }
        }
        return (y + l);
    }
}



function setGetXByYFunction(r) {
    r.getXByY = function (y) {
        //以所有拟合点按顺序比较与所求y值的差距，斜率由正负数变化（变为0也算）前为一阶段，差距最小的一个点，即为这一阶段的交点
        //同时要多增加一个判断，如果所求y值在这一段的的y值范围之外，实际上是没有交点的

        var findPoints = [];//记录找到的所有交点（[x,y]）

        var findPoint = null;//本阶段内找到的交点
        var findDifference = 99999999;//当前找到的交点与所求y值的差值
        var minYPoint = null;//本阶段y值最小点
        var maxYPoint = null;//本阶段y值最大点
        var xl = 0;//斜率  尾点的斜率被认为是0

        //循环处理点
        for (var i = 0; i < r.newSerialData.length; i++) {
            var item = r.newSerialData[i];

            //求交点(与所求y值相差最小的点)
            var nowDifference = Math.abs(item[1] - y);
            if (findPoint == null || nowDifference < findDifference) {
                findPoint = item;
                findDifference = nowDifference;
            }

            //记录y最大最小点
            if (minYPoint == null || minYPoint[1] > item[1]) {
                minYPoint = item;
            }
            if (maxYPoint == null || maxYPoint[1] < item[1]) {
                maxYPoint = item;
            }

            //求与下一个点的斜率  
            var nowXl = 0;
            if (i < r.newSerialData.length - 1) { //尾点没有下一个点，斜率被认为是0
                var nextItem = r.newSerialData[i + 1];
                var yy = nextItem[1] - item[1];
                var xx = nextItem[0] - item[0];
                if (xx == 0) {//如果是垂直线，斜率为正、负无穷大，给一个很大、很小的数值
                    nowXl = yy > 0 ? 99999999 : -99999999;
                } else if (yy == 0) {//如果是水平线，斜率为0
                    nowXl = 0;
                } else {
                    nowXl = yy / xx;
                }
            }

            //斜率变化后，得到交点，存入结果数组
            if (i > 0) {//i>0才做斜率变化判断
                if (signChanged(xl, nowXl)) {//如果斜率正负改变，被视为一个阶段的结束
                    //所求y值在此阶段内时，交点才是真正的交点
                    if (findPoint && minYPoint && maxYPoint && y >= minYPoint[1] && y <= maxYPoint[1]) {
                        findPoints.push(findPoint);
                    }
                    //重新初始化环境
                    findPoint = item;
                    findDifference = nowDifference;
                    minYPoint = item;
                    maxYPoint = item;
                }
            }

            //记录本点的斜率
            //console.info(xl + "      " + nowXl);
            xl = nowXl;
        }

        //返回结果
        r.intersects = [];
        for (var i = 0; i < findPoints.length; i++) {
            var p = findPoints[i];
            r.intersects.push(p);
        }
        if (findPoints.length > 0) {
            return findPoints[0][0];
        } else {
            return null;
        }
    };
}


